export default __webpack_public_path__ + "static/media/icon_bow.7ceaa8e2.png";